import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestOtpApi, checkUserSubscriptionApi } from '../http/http'; 
import { generateTrackingId } from '../utils/genrateId';
import toast, { Toaster } from 'react-hot-toast';
import classes from './SubscribePage.module.css';

const SubscribePage = () => {
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSendOtp = async (e) => {
        e.preventDefault();
        
        if (phone.length < 9) {
            toast.error("Please enter a valid mobile number");
            return;
        }

        setLoading(true);
        const loadingToast = toast.loading('Checking status...');

        try {
            // --- 1. PRE-CHECK: Is the user already Registered or Pending? ---
            try {
                const statusRes = await checkUserSubscriptionApi(phone);
                
                
                let userStatus = 
                    statusRes.data?.data?.status || 
                    statusRes.data?.status || 
                    statusRes.data?.data?.subscriptionStatus || 
                    statusRes.data?.subscriptionStatus || 
                    statusRes.data?.data?.subscription_status || 
                    '';

                userStatus = userStatus.toUpperCase();

                if (userStatus === 'REGISTERED') {
                    const userData = {
                        msisdn: phone,
                        masked_msisdn: statusRes.data?.data?.masked_msisdn || '',
                        status: 'REGISTERED'
                    };
                    localStorage.setItem('userData', JSON.stringify(userData));
                      if (statusRes.data?.token) {
                        localStorage.setItem('token', statusRes.data.token);
                    }

                    toast.success("You are already subscribed! Redirecting to Homepage...", { id: loadingToast, duration: 3000 });
                    setTimeout(() => navigate('/'), 2000);
                    setLoading(false);
                    return; // STOP EXECUTION
                } else if (userStatus === 'REG_PENDING' || userStatus === 'PENDING') {
                    toast.error("Your subscription is pending billing. Please top up your balance and log in.", { id: loadingToast, duration: 4000 });
                    setTimeout(() => navigate('/login'), 3000);
                    setLoading(false);
                    return; // STOP EXECUTION
                }
            } catch (checkErr) {
               
                console.log("Check API Error (Likely New User):", checkErr.response?.data || checkErr.message);
            }
            // ----------------------------------------------------------------

            // --- 2. SEND OTP (For New Users Only) ---
            toast.loading('Sending OTP...', { id: loadingToast }); 
            
            const ext_ref = generateTrackingId(); 
            const response = await requestOtpApi(phone, ext_ref);

            if (response.data) {
                
                toast.success("OTP Sent Successfully!", { id: loadingToast });
            localStorage.setItem('otpRequested',true);
                navigate('/otp', {
                    state: {
                        phone,
                        referenceNo: response.data.data?.referenceNo || response.data.referenceNo,
                        ext_ref
                    }
                });
               
            }
        } catch (err) {
            // --- FIX: Dynamically read the backend message for 409 errors ---
            if (err.response?.status === 409) {
                const backendMsg = err.response?.data?.message || "You are already subscribed! Redirecting to login...";
                
                toast.error(backendMsg, { id: loadingToast, duration: 4000 });
                setTimeout(() => navigate('/login'), 3000);
            } else {
                const msg = err.response?.data?.message || 'Something went wrong';
                toast.error(msg, { id: loadingToast });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={classes.page_wrapper}>
            <Toaster position="top-center" reverseOrder={false} />
            
            <div className={classes.bg_blob_1}></div>
            <div className={classes.bg_blob_2}></div>

            <div className={classes.card}>
                <div className={classes.logo_area}>
                    <div className={classes.logo_icon_wrap}>
                        <img
                            src="/assets/images/logo.png"
                            alt="GamePlex logo"
                            className={classes.logo_icon}
                        />
                    </div>
                    <p className={classes.logo_text}>
                        Game<span>Plex</span>
                    </p>
                </div>

                <div className={classes.heading_area}>
                    <h1 className={classes.title}>Join Us</h1>
                    <p className={classes.subtitle}>
                        Enter your mobile number to get started.
                    </p>
                </div>

                <form className={classes.form} onSubmit={handleSendOtp}>
                    
                    {/* Phone Input */}
                    <div>
                        <span className={classes.field_label}>Mobile Number</span>
                        <div className={classes.input_group}>
                            <span className={classes.input_prefix}>+94</span>
                            <input
                                className={classes.input}
                                type="tel"
                                placeholder="7XXXXXXXX"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))} 
                                maxLength={12}
                                disabled={loading}
                            />
                        </div>
                        <p className={classes.sms_note}>
                            Standard data and SMS rates may apply.
                        </p>
                    </div>

                    {/* --- SMALL UI INFO BOXES --- */}
                    <div className={classes.pack_selection}>
                        <div className={classes.pack_cards}>
                            <div className={classes.pack_card}>
                                <div className={classes.pack_title}>Daily Plan</div>
                                <div className={classes.pack_type}>Prepaid</div>
                                <div className={classes.pack_price}>LKR 10<span>/day</span></div>
                            </div>
                            
                            <div className={classes.pack_card}>
                                <div className={classes.pack_title}>Monthly Plan</div>
                                <div className={classes.pack_type}>Postpaid</div>
                                <div className={classes.pack_price}>LKR 300<span>/month</span></div>
                            </div>
                        </div>
                    </div>
                    {/* --------------------------- */}

                    <button type="submit" className={classes.submit_btn} disabled={loading}>
                        {loading ? 'Processing...' : 'Send OTP'}
                    </button>
                </form>

                <p className={classes.consent_text}>
                    By continuing, you agree to our{' '}
                    <span className={classes.consent_link} onClick={() => navigate('/privacy-policy')}>Terms of Service</span>
                    {' '}and{' '}
                    <span
                        className={classes.consent_link}
                        onClick={() => navigate('/privacy-policy')}
                    >
                        Privacy Policy
                    </span>
                </p>

                <p className={classes.back_row}>
                    Already have an account?{' '}
                    <button
                        type="button"
                        className={classes.back_link}
                        onClick={() => navigate('/login')}
                    >
                        Login
                    </button>
                </p>
            </div>
        </div>
    );
};

export default SubscribePage;